import { FETCH_MAP } from '../constants/action-types';

const initState = {
    maps : []
}

const mapReducer = (state = initState, action) => {
    switch(action.type){
        case FETCH_MAP:
            return {
                ...state,
                maps: [... state.maps, action.maps]
            }
        default:
            return state;
    }
}

export default mapReducer